import { CountriesList } from "./types/processTypes";

/** Destinations with no embassy step — visa is auto-issued when medical is FIT. */
export const NO_EMBASSY_COUNTRIES = [
  CountriesList.kuwait,
  CountriesList.qatar,
  CountriesList.uae,
] as const;

export function isNoEmbassyCountry(country?: string | null): boolean {
  if (!country) return false;
  return (NO_EMBASSY_COUNTRIES as readonly string[]).includes(country);
}
